// extracted by mini-css-extract-plugin
export default {"contacts":"cP0U3eXPV","obfuscateEmail":"ch6HFlWlI"};